import { useApi } from '@hooks/useApi';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@utils/consts';
import { AcquirerUser } from '@root/globalTypes';

export function useGetAcquirerUser({ acquirerId, id }: { acquirerId: string; id: string }) {
  const { query } = useApi();

  const { data, isPending } = useQuery<AcquirerUser>({
    queryKey: [...queryKeys.acquirerUsers, id],
    queryFn: (): Promise<AcquirerUser> =>
      query({
        path: `v1/staff/acquirers/${acquirerId}/users/${id}`,
      }),
    enabled: Boolean(id),
  });

  return {
    data: data,
    isPending,
  };
}
